const fireViewEndCustomEvent = () => {
  let event = new CustomEvent('eventViewEnd');
  let obj = document.querySelector('body');
  obj.dispatchEvent(event);
};

const fireViewStartCustomEvent = data => {
  let event = new CustomEvent('eventReactViewStart', data);
  document.dispatchEvent(event);
};

const fireActionTriggerCustomEvent = (target, data) => {
  let event = new CustomEvent('eventActionTrigger', data);
  target.dispatchEvent(event);
};

export { fireViewEndCustomEvent, fireViewStartCustomEvent, fireActionTriggerCustomEvent };
